<template>
  <div class="link">
    <a
      :href="url"
      target="_blank"
      rel="noopener"
      data-anim="fade"
      data-view="false"
      :aria-label="text"
    >
      <div
        class="link__line link__line--first"
        data-anim="line"
        data-view="false"
      >
        <div class="link__line__inner link__line__inner--first" />
        <div class="link__line__inner link__line__inner--last" />
      </div>
      {{ text }}
    </a>
    <!-- <div
      class="link__line link__line--last"
      data-anim="line"
      data-view="false"
    /> -->
  </div>
</template>

<script>
export default {
  name: 'Link',

  props: {
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.link {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  a {
    font-size: rem(16px);
    font-weight: 500;

    padding-right: rem(20px);

    @include mq(ipadP) {
      padding-right: rem(30px);
    }

    @include mq(ds) {
      padding-right: rem(60px);
    }

    &:hover {
      .link__line__inner {
        &--first {
          transform: translate3d(102%, 0, 0);
          transition-delay: 0s;
        }

        &--last {
          transform: translate3d(0%, 0, 0);
          transition-delay: .4s;
        }
      }
    }
  }

  &__line {
    height: 1px;
    background-color: $color-dark-light;

    &--first {
      position: absolute;
      top: 50%;
      left: rem(-100px);
      background-color: transparent;
      overflow: hidden;

      width: rem(20px);

      @include mq(ipadP) {
        width: rem(30px);
      }

      @include mq(ds) {
        width: rem(60px);
      }
    }

    &--last {
      position: relative;
      flex: 1 1 0;
    }

    &__inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: $color-dark-light;
      transition: transform .8s $outExpo;

      &--first {
        transform: translate3d(0%, 0, 0);

        transition-delay: .4s;
      }

      &--last {
        transform: translate3d(-102%, 0, 0);
      }
    }
  }
}
</style>